module.exports = __webpack_public_path__ + "img/specialist_icon.8790bb3b.svg";